import { AbstractCommand } from "@astina/paloma-common-ui/src/services/CommandQueue";
import env from '../services/AppEnv';
import alerts from '@astina/paloma-common-ui/src/services/Alerts';
import paloma from '@astina/paloma-common-ui/src/services/PalomaBackend';
import translate from '@astina/paloma-common-ui/src/services/Translator';
import ValidationUtils from "@astina/paloma-common-ui/src/services/ValidationUtils";
import orderUtils from "@astina/paloma-shop-common-ui/src/services/OrderUtils";
import events from '@astina/paloma-common-ui/src/services/EventBus';
export function addCartItems(items, cartId) {
    return new AddCartItems(items, cartId)
        .enqueue();
}
export function addCartItem(item, cartId) {
    return addCartItems([item], cartId);
}
export default class AddCartItems extends AbstractCommand {
    items;
    cartId;
    constructor(items, cartId) {
        super();
        this.items = items;
        this.cartId = cartId;
    }
    execute() {
        return paloma
            .execute(this.name(), {
            cartId: this.cartId || env.orders.activeDraft,
            items: this.items
        })
            .then((cart) => {
            orderUtils.handleCartModifications(cart);
            events.$emit('track.add_to_cart', { addedItems: cart.addedItems, currency: cart.currency });
            return cart;
        })
            .catch((error) => {
            try {
                const validation = ValidationUtils.createValidation(error);
                ValidationUtils.alertAll(validation);
            }
            catch (e) {
                alerts.error(translate(`command.${this.name()}.error`));
            }
            throw error;
        });
    }
    name() {
        return 'add_cart_items';
    }
    icon() {
        return 'shopping-cart';
    }
    needsConfirmation() {
        return this.items.length > 10;
    }
    requiresPermission() {
        return 'PORTAL_ORDERS_CREATE';
    }
}
